import "./TestBlock.scss";
import { define, mount } from "@shared/Lib/registry";
import type { Component } from "@shared/Lib/types";
import type { ButtonClickDetail } from "@shared/Components/Atoms/Button/Button";

class TestBlock implements Component {
  readonly el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    mount(el);
    this.init();
  }

  private init(): void {
    console.log("[TestBlock] initialized", this.el);

    this.el.addEventListener("button:click", this.handleButtonClick);
  }

  private handleButtonClick = (e: Event): void => {
    const { variant } = (e as CustomEvent<ButtonClickDetail>).detail;
    console.log(`[TestBlock] button:click received — variant: ${variant}`);

    this.el.classList.add("test-block--interacted");
  };

  destroy(): void {
    this.el.removeEventListener("button:click", this.handleButtonClick);
  }
}

define("test-block", (el) => new TestBlock(el));
